export const fontFamily = {
  sans: `Approach,-apple-system, system-ui, "San Francisco", "Segoe UI", Roboto, "Helvetica Neue", sans-serif;`,
};
